import {
  PayPalScriptProvider,
  PayPalButtons,
} from "@paypal/react-paypal-js";
import Modal, { ModalBody } from "../../Components/Modal/Modal";
import { createOrder } from "../../Store/actions/OrdersActions";
import classes from "./PayPal.module.css";
import { useSelector } from "react-redux";

const PayPalCard = ({ billingAddress,onClose }) => {
  const url = window.location.href;
  const domainName = url.substring(0, url.lastIndexOf(`/`));
  const currentUser = useSelector((state) => state.user.currentUser);

  function create() {
    return createOrder(billingAddress,"paypal").then((order) => {
      return order.data.orderId;
    });
  }
  function onApprove(data) {
    if (data.paymentID) {
      window.location.href = `${domainName}/payment.html?payment_intent=${data.paymentID}`;
    }
  }

  return (
    <Modal className={classes.modal} title="Payment" onClose={onClose}>
      <ModalBody>
        <div className={classes.main}>
          <PayPalScriptProvider
            options={{
              clientId:
              "AX13L1EtxodlN9PsAg_IFeF5IgKjpY5KMxyeHwKmXRD3NJJps5-IRs7bCS27D15nsvjuYpBWYPKbwJzE",
                currency:currentUser?.preferredCurrency
            }}
          >
            <PayPalButtons createOrder={create} onApprove={onApprove} />
          </PayPalScriptProvider>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PayPalCard;
